import initSelectCustom from '@ui/Form/Fields/SelectCustom/component'

export default function (): void {
  document.querySelectorAll<HTMLDetailsElement>('form.search-form details.o-select-custom').forEach((el) => {
    initSelectCustom(el)
  })
}
